module.exports = __webpack_public_path__ + "img/jx3box_qqbot_qq.76dab1f4.svg";